<template>
  <v-data-table :headers="cidItemHeaders" :items="cidItems" sort-by="description">
    <template v-slot:top>
      <v-toolbar flat>
        <v-row align="center">
          <v-col class="text-subtitle-2 gray--text text--lighten-1">
            Sub cids
          </v-col>

          <v-spacer />

          <v-col cols="auto">
            <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
                  Novo sub Cid
                </v-btn>
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container fluid>
                    <v-row dense>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          dense
                          v-model="editedItem.description"
                          label="Descrição"
                          :hide-details="!errors.editedItem"
                          :error-messages="errors.editedItem"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancelar
                  </v-btn>

                  <v-btn color="blue darken-1" text @click="save">
                    Salvar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_diagnostic_hypothesis"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_diagnostic_hypothesis"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há dados cadastrados
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: "CidItemTable",
    props: {
      cid: Object,
      refreshList: Function,
    },
    data() {
      return {
        errors: {},
        dialog: null,
        editedItem: {},
        editedIndex: -1,
        cidItemHeaders: [
          { text: "Descrição", value: "description" },
          { text: "Ações", value: "actions", sortable: false, align: "end" },
        ],
      };
    },
    computed: {
      cidItems() {
        return this.cid.cidItems;
      },
      formTitle() {
        return this.editedIndex === -1 ? "Novo sub cid" : "Editar sub cid";
      },
    },
    methods: {
      editItem(item) {
        this.editedIndex = this.cidItems.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        if (confirm("Você realmente deseja deletar esse facilitador?")) {
          this.apolloMutate({
            mutation: require("@/graphql/diagnostic_hypothesis/delete_cid_item.gql"),
            variables: {
              cidItemId: item.id,
            },
          }).then(() => {
            this.refreshList();

            this.$store.dispatch("createNotification", {
              message: "Cadastro excluido com sucesso.",
              type: "success",
            });
          });
        }
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {
        if (!this.validate()) return;

        this.apolloMutate({
          mutation: require("@/graphql/diagnostic_hypothesis/save_cid_item.gql"),
          variables: {
            cidId: this.cid.id,
            cidItemId: this.lodash.get(this.editedItem, "id", ""),
            description: this.editedItem.description,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });

        this.close();
      },
       validate() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        let description = this.editedItem.description;
        if (this.lodash.isEmpty(description?.trim())) {
          this.errors.editedItem = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
